/**
 * Combat rig — combat-feel focused diagnostic surface.
 *
 * Opens combat-relevant debug tools: Debug Info (entity inspector),
 * Event Rate (cast → damage → VFX chain), Smoothness Dashboard for
 * top-line health. Trackers enabled so frame jitter during high-VFX
 * ability casts is captured.
 *
 * Use during combat playtests where the question is "does fighting
 * feel responsive" — different focus than the smoothness-arc rig
 * which is "does walking feel smooth."
 */

import type { PlaytestRig } from '../environment/devConfig';

export const COMBAT_RIG: PlaytestRig = {
  enabled: true,
  label: 'combat-2026-05-13',
  toolsToOpen: [
    'smoothnessDashboard',
    'eventRate',
    'debugInfo',
    'frameJitter',
  ],
  enableFrameJitterTracking: true,
  enableReactRenderTracking: true,
  trackerEnableDelayMs: 10000,
};
